import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ContactUs() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (!formData.name.trim()) {
      setError('Please enter your name');
      return;
    }
    if (!formData.email.trim()) {
      setError('Please enter your email');
      return;
    }
    if (!formData.subject.trim()) {
      setError('Please enter a subject');
      return;
    }
    if (!formData.message.trim()) {
      setError('Please enter your message');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }

    // Here you would typically send the form data to your backend
    // For now, we'll just show a success message
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });

    // Reset the success message after 5 seconds
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className="policy-page-container">
      {/* Header */}
      <header className="policy-page-header">
        <div className="policy-header-content">
          <h1>Contact Us</h1>
          <button className="btn-home" onClick={() => navigate('/')}>
            🏠 HOME
          </button>
        </div>
      </header>

      {/* Content */}
      <div className="content-wrapper">
      <div className="content-inner">
        <div className="card-container">
          <h2 className="section-title mb-2">📧 Contact Us</h2>
          <p className="section-subtitle mb-4">Get in touch with our support team</p>

          <div className="contact-content">
            <div className="contact-grid">
              {/* Contact Info */}
              <div className="contact-info-section">
                <h3>Get in Touch</h3>
                <p>Have questions or need assistance? We're here to help! Reach out to us through any of the following methods:</p>

                <div className="contact-methods">
                  <div className="contact-method">
                    <div className="method-icon">📧</div>
                    <div className="method-content">
                      <h4>Email</h4>
                      <p>
                        <a href="mailto:support@stick.audio" className="contact-link">
                          support@stick.audio
                        </a>
                      </p>
                      <small>We typically respond within 24 hours</small>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">⏱️</div>
                    <div className="method-content">
                      <h4>Response Time</h4>
                      <p>Business days: 9 AM - 6 PM UTC</p>
                      <small>Quick responses to urgent issues</small>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">🔧</div>
                    <div className="method-content">
                      <h4>Support Topics</h4>
                      <p>API issues, billing, technical support, feature requests, and more</p>
                    </div>
                  </div>
                </div>

                <div className="faq-section">
                  <h4>Common Questions</h4>
                  <ul>
                    <li><strong>How do I get my API key?</strong> - Navigate to the API Access tab after signing in</li>
                    <li><strong>What payment methods do you accept?</strong> - We accept all major credit cards via Stripe</li>
                    <li><strong>Can I delete my account?</strong> - Yes, contact support and we'll help you</li>
                    <li><strong>How do credits work?</strong> - 1 credit = 1 character generated. Credits never expire</li>
                  </ul>
                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-form-section">
                <h3>Send us a Message</h3>

                {submitted && (
                  <div className="success-message">
                    <p>✅ Thank you for reaching out! We'll get back to you soon.</p>
                  </div>
                )}

                {error && (
                  <div className="error-message">
                    <p>❌ {error}</p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="How can we help?"
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us more about your inquiry..."
                      className="form-textarea"
                      rows="6"
                    />
                  </div>

                  <button type="submit" className="btn btn-primary btn-submit">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default ContactUs;
